/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class UserOfferSourceAnalysisItemSourceEnum.
* @enum {}
* @readonly
*/
export default class UserOfferSourceAnalysisItemSourceEnum {
    
        /**
         * value: "top"
         * @const
         */
        "top" = "top";

    
        /**
         * value: "agent_search"
         * @const
         */
        "agent_search" = "agent_search";

    
        /**
         * value: "search_result"
         * @const
         */
        "search_result" = "search_result";

    
        /**
         * value: "top_via_detail"
         * @const
         */
        "top_via_detail" = "top_via_detail";

    
        /**
         * value: "agent_search_via_detail"
         * @const
         */
        "agent_search_via_detail" = "agent_search_via_detail";

    
        /**
         * value: "search_result_via_detail"
         * @const
         */
        "search_result_via_detail" = "search_result_via_detail";

    
        /**
         * value: "limited_property"
         * @const
         */
        "limited_property" = "limited_property";

    
        /**
         * value: "limited_property_via_detail"
         * @const
         */
        "limited_property_via_detail" = "limited_property_via_detail";

    
        /**
         * value: "learning_article"
         * @const
         */
        "learning_article" = "learning_article";

    
        /**
         * value: "learning_article_via_detail"
         * @const
         */
        "learning_article_via_detail" = "learning_article_via_detail";

    
        /**
         * value: "similar_agent_via_detail"
         * @const
         */
        "similar_agent_via_detail" = "similar_agent_via_detail";

    
        /**
         * value: "diagnosis_compatibility_agents_via_detail"
         * @const
         */
        "diagnosis_compatibility_agents_via_detail" = "diagnosis_compatibility_agents_via_detail";

    
        /**
         * value: "registration_compatibility_agents"
         * @const
         */
        "registration_compatibility_agents" = "registration_compatibility_agents";

    
        /**
         * value: "registration_compatibility_agents_via_detail"
         * @const
         */
        "registration_compatibility_agents_via_detail" = "registration_compatibility_agents_via_detail";

    
        /**
         * value: "diagnosis_compatibility_agents"
         * @const
         */
        "diagnosis_compatibility_agents" = "diagnosis_compatibility_agents";

    

    /**
    * Returns a <code>UserOfferSourceAnalysisItemSourceEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/UserOfferSourceAnalysisItemSourceEnum} The enum <code>UserOfferSourceAnalysisItemSourceEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

